<template>
    <div>
        <my-dialog :is-show="showCart" @on-close="closeDialog" class='home_addcart' v-if='item'>
            <div class="cart-dialog">
                <div class="cart-content">
                    <div class="cart-pro flex-h flex-hw">
                        <div class="pro-img">
                            <div class="swiper-container swiper_wrap">
                                <div class="swiper-wrapper">
                                    <template v-for='imgs in item.list' v-if='imgs.id==pound_index'>
                                        <div class="swiper-slide" v-for='(img,index) in imgs.pic.list'>
                                            <img :src="imgs.pic.url+img.s" @click='viewImage(index,imgs.pic.list,imgs.pic.url)'>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="content">
                            <p><h2>{{item.name}}</h2></p>
                            <template v-if='item.french'><p>{{item.french}}</p></template>
                            <template v-else><p>{{item.fname}}</p></template>
                            <h2>¥<template v-for='data in item.list' v-if='data.id==pound_index'>{{data.pprice}}</template></h2>
                            <p><h2 v-if="item.name=='餐具'" style="color: #f0250f;">1包餐具包含：5个餐盘、5把餐勺</h2></p>
                            <p><h2><template v-for='data in item.list' v-if='data.id==pound_index&&data.fittings.length>0'>
                            <img src="/static/images/icon_nb1.png" style="width:0.3rem;margin-right: 0.1rem;">含{{data.fittings}}
                            </template></h2></p>
                            <p><h2 v-if="item.goodsTips" style="color: #f0250f;">{{item.goodsTips}}</h2></p>
                        </div>
                    </div>
                    <div class="cart-line">
                        <div class="items">
                            <h3>规格选择</h3>
                            <select v-model='pound_index' @change='changeIndex' @blur="scrollTo">
                                <option :value="data.id" v-for='(data,index) in item.list'>
                                    {{data.spec}}
                                    <template v-if='data.weight'>（{{data.weight}}）</template>
                                    <template v-if='data.edible'> - {{data.edible}}</template>
                                </option>
                            </select>
                            <span class="cart_guige" v-for='(data,index) in item.list' v-if='pound_index==data.id'>
                                {{data.spec}}
                                <template v-if='data.weight'>（{{data.weight}}）</template>
                                <template v-if='data.edible'> - {{data.edible}}</template>
                            </span>
                            <i class="icon iconsfont icons-jiantouxia"></i>
                        </div>
                    </div>
                    <div class="cart-line">
                        <div class="items">
                            <h3>数量选择</h3>
                            <div class="nums">
                                <van-stepper @plus='plus' v-model="value" :default-value="value" max=50 />
                            </div>
                        </div>
                    </div>
                    <div class="btns2">
                        <ul>
                            <li class="cancel btn-cancel" @click='closeDialog'><span>取消</span></li>
                            <li class="btn-ok" @click='addcart(item.cartName)'><span>确认</span></li>
                        </ul>
                    </div>
                </div>
            </div>
        </my-dialog>
    </div>
</template>

<script>
  import Swiper from '../../static/js/swiper.min.js'
  import dialog from '../components/dialog'
  import '../style/css/cart.css'
  import '../../static/css/swiper.min.css'
  import { ImagePreview } from 'vant'
  import {mapActions} from 'vuex'

  export default {
    name: 'list',
    components: {
      myDialog: dialog
    },
    data () {
      return {
        loading: false,
        isblur: false,
        showChildMsg: 'ddddd',
        isShowDialog: true,
        prolist: [],
        data: '',
        value: '1',
        pound_index: 0,
        imgArr: [],
        instance: '',
        swiper: '',
        spaceBetween: 0
      }
    },
    filters: {},
    activated () {

    },
    deactivated: function () {
      this.imgArr = []
    },
    mounted () {
      let self = this
      this.value = this.item && this.item.num ? this.item.num : 1
      this.pound_index = this.item ? this.item.list[0].id : ''
      self.spaceBetween > 0 ? self.spaceBetween = -2 : self.spaceBetween = 2
    },
    watch: {
      item: function () {
        let self = this
        if (self.swiper && self.swiper.el) {
          self.swiper.destroy(true, true)
        }
        this.value = this.item && this.item.num ? this.item.num : 1
        this.pound_index = this.item.id
        self.$nextTick(function () {
          self.swiper = new Swiper('.swiper_wrap', {
            //autoplay: true,
            slidesPerView: 1,
            disableOnInteraction: false,
            spaceBetween: 20

          })
        })
      },
      '$route': function () {
        if (this.instance) {
          this.instance.close()
        }
      },
      'cartModel.num': function () {
        if (this.$route.path.indexOf('/detail') >= 0) {
          return false
        }
        let self = this
        if (self.swiper && self.swiper.el) {
          self.swiper.destroy(true, true)
        }
        this.value = this.item && this.item.num ? this.item.num : 1
        this.pound_index = this.item.id
        self.$nextTick(function () {
          self.swiper = new Swiper('.swiper_wrap', {
            //autoplay: true,
            slidesPerView: 1,
            disableOnInteraction: false,
            spaceBetween: 20

          })
        })
      }
    },
    props: ['item', 'showCart', 'cartModel'],
    methods: {
      ...mapActions({
        add: 'addCart' // 将 `this.add()` 映射为 `this.$store.dispatch('increment')`
      }),
      changeIndex () {
        let self = this
        this.value = this.item && this.item.num ? this.item.num : 1
        if (self.swiper && self.swiper.el) {
          self.swiper.destroy(true, true)
        }
        self.$nextTick(function () {
          self.swiper = new Swiper('.swiper_wrap', {
            //autoplay: true,
            slidesPerView: 1,
            disableOnInteraction: false,
            spaceBetween: 20
          })
        })
      },
      scrollTo () {
        setTimeout(function () {
          window.scrollTo(0, Math.max((document.documentElement.scrollTop || document.body.scrollTop || 0) - 1, 0))
        }, 100)
      },
      viewImage (index, imgs, url) {
        this.imgArr = []
        for (let i = 0; i < imgs.length; i++) {
          this.imgArr.push(url + imgs[i].m)
        }
        this.instance = ImagePreview(this.imgArr, index)
      },
      confirm () {
        if (this.item) {
          this.item.num = this.value
          this.item.price = this.item.salePrice[this.pound_index]
        }
        this.Toast('操作成功')
        this.$emit('closeDialog')
      },
      plus () {

      },
      closeDialog () {
        let self = this
        this.value = this.item.num
        this.pound_index = this.item.list[0].id
        if (self.swiper && self.swiper.el) {
          self.swiper.destroy(true, true)
        }
        this.$emit('closeDialog')
      },
      addcart (type) {
        let self = this
        if (!self.value || self.value == '') {
          self.Toast({
            message: '请选择商品数量',
            duration: 500
          })
          return false
        }
        if (type == 'edit') {
          self.Loading.open()
          self.$http.post(self.host + '/api/b34ce2c4f51281f9', {
            id: self.item.key,
            num: self.value,
            sid: self.pound_index,
            cityId: store.get('city_id') ? store.get('city_id') : 110,
            uid: window.cookie.get('_uid') ? window.cookie.get('_uid') : 0
          }).then(function (res) {
            self.Loading.close()
            let num = 0
            for (let item in res.data) {
              num += (res.data[item].num - 0)
            }
            if (res.code == 1) {
              self.Toast({
                message: '修改成功',
                duration: 500
              })
              self.$emit('changenum', res.data, num)
              self.add(res.data.master.goodsNum)
            } else {
              //self.$emit('changenum', 0)
              self.Toast(res.msg)
            }
          }, function (error) {
            console.log(error)
          })
        } else {
          let self = this
          self.Loading.open()
          self.$http.post(self.host + '/api/0a726336d3a19773', {
            id: self.pound_index,
            num: self.value,
            cartName: type,
            cityId: store.get('city_id') ? store.get('city_id') : 110,
            uid: window.cookie.get('_uid') ? window.cookie.get('_uid') : 0
          }).then(function (res) {
            self.Loading.close()
            if (res.code == 1) {
              let num = res.data.master.num
              let product_price = 0
              $.each(self.item.list, function (i, v) {
                if (v.id == self.pound_index) {
                    product_price = v.pprice
                }
              })
              if (type == 'shop') {
                _hmt.push(['_trackCustomEvent', 'add_to_cart', {
                    "product_name": self.item.name,
                    "product_price": product_price
                  }
                ])
                self.Toast({
                  message: '已成功加入购物车！',
                  duration: 500
                })
                self.$emit('closeDialog', num)
                self.$emit('changeList')
              } else {
                _hmt.push(['_trackCustomEvent', 'buy_now', {
                    "product_name": self.item.name,
                    "product_price": product_price
                  }
                ])
                store.set('checkout_init', '1')
                self.$router.push('/cart')
                self.$emit('closeDialog', num)
              }
              self.add(res.data.master.goodsNum)
            } else {
              self.MessageBox({
                closeOnClickModal: false,
                title: '提示',
                message: res.msg,
                showCancelButton: false,
                cancelButtonText: '继续逛逛'
              }).then(action => {})
              self.$emit('changenum', 0)
            }
          }, function (error) {
          })
        }
      }
    }
  }
</script>

<style scoped>
    .dialog-close {
        right: .4rem;
        top: .2rem;
    }

    .swiper-slide {
        float: none;
    }

    .swiper-slide img {
        display: block;
    }

    .cart-dialog .cart-content .cart-pro .pro-img {
        width: 2.62rem;
        height: 2.62rem;
        padding: 0.01rem;
        background-color: #fff;
    }

    .cart_guige {
        position: absolute;
        flex: 2;
        right: 0;
        text-align: left;
        padding-right: 1rem;
        z-index: 1
    }

    .cart-dialog .cart-content .items select {
        position: relative;
        z-index: 2;
        opacity: 0;
    }

    .btns2 ul {
        border-radius: 0 0 5px 5px;
        overflow: hidden;
    }

    .cart-dialog .cart-content .cart-pro .content, .cart-dialog .cart-content .cart-pro .content h2 {
        font-size: .3rem;
        font-weight: normal;
    }


</style>



// WEBPACK FOOTER //
// src/components/cart-dialog.vue